import { useState } from 'react';
import { Link } from 'react-router-dom';

export function ServiceAreaMap() {
  const [activeArea, setActiveArea] = useState<string | null>(null);

  const serviceAreas = [
    // Main Las Vegas Valley
    { name: 'Las Vegas', description: 'Main service hub', link: '/service-areas/las-vegas' },
    { name: 'Henderson', description: 'Full service coverage', link: '/service-areas/henderson' },
    { name: 'North Las Vegas', description: 'Full service coverage', link: null },
    { name: 'Summerlin', description: 'Full service coverage', link: '/service-areas/summerlin' },
    { name: 'Green Valley', description: 'Full service coverage', link: null },
    { name: 'Paradise', description: 'Full service coverage', link: null },
    { name: 'Spring Valley', description: 'Full service coverage', link: null },
    { name: 'Enterprise', description: 'Full service coverage', link: null },
    { name: 'Sunrise Manor', description: 'Full service coverage', link: null },
    { name: 'Whitney', description: 'Full service coverage', link: null },
    { name: 'Winchester', description: 'Full service coverage', link: null },
    { name: 'Centennial Hills', description: 'Full service coverage', link: null },
    { name: 'Aliante', description: 'Full service coverage', link: null },
    { name: 'Anthem', description: 'Full service coverage', link: null },
    { name: 'Seven Hills', description: 'Full service coverage', link: null },
    { name: 'MacDonald Ranch', description: 'Full service coverage', link: null },
    { name: 'Mountains Edge', description: 'Full service coverage', link: null },
    { name: 'Southern Highlands', description: 'Full service coverage', link: null },
    { name: 'Skye Canyon', description: 'Full service coverage', link: null },
    { name: 'Providence', description: 'Full service coverage', link: null },
    { name: 'Tule Springs', description: 'Full service coverage', link: null },
    { name: 'Lone Mountain', description: 'Full service coverage', link: null },
    { name: 'The Lakes', description: 'Full service coverage', link: null },
    { name: 'Desert Shores', description: 'Full service coverage', link: null },
    { name: 'Silverado Ranch', description: 'Full service coverage', link: null },
    { name: 'Rhodes Ranch', description: 'Full service coverage', link: null },
    { name: 'Inspirada', description: 'Full service coverage', link: null },
    { name: 'Cadence', description: 'Full service coverage', link: null },
    { name: 'Lake Las Vegas', description: 'Full service coverage', link: null },
    // Extended Coverage (within 45 miles)
    { name: 'Boulder City', description: 'Extended coverage', link: null },
    { name: 'Blue Diamond', description: 'Extended coverage', link: null },
    { name: 'Mt Charleston', description: 'Extended coverage', link: null },
    { name: 'Indian Springs', description: 'Extended coverage', link: null },
    { name: 'Primm', description: 'Extended coverage', link: null },
    { name: 'Jean', description: 'Extended coverage', link: null },
    { name: 'Goodsprings', description: 'Extended coverage', link: null },
    { name: 'Sloan', description: 'Extended coverage', link: null },
    { name: 'Moapa', description: 'Extended coverage', link: null },
    { name: 'Logandale', description: 'Extended coverage', link: null },
    { name: 'Pahrump', description: 'Extended coverage', link: null },
    { name: 'Cold Creek', description: 'Extended coverage', link: null },
    { name: 'Red Rock', description: 'Extended coverage', link: null },
  ];

  return (
    <section id="service-areas" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-2 mb-3">
            <div className="w-2 h-2 bg-[#FF6B35] rounded-full"></div>
            <span className="text-[#FF6B35] text-sm font-semibold tracking-wider uppercase">Service Areas</span>
          </div>
          <h2 className="text-5xl font-bold text-[#2C2C2C] mb-4">Proudly Serving Las Vegas Valley</h2>
          <p className="text-gray-600 text-base max-w-2xl mx-auto">
            We provide professional construction and home improvement services within a 45-mile radius of Las Vegas
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8">
          <div>
            <div className="rounded-2xl overflow-hidden shadow-lg h-[600px]">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d413370.0693893!2d-115.46234!3d36.1249!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80beb782a4f57dd1%3A0x3accd5e6d5b379a3!2sLas%20Vegas%2C%20NV!5e0!3m2!1sen!2sus!4v1699999999999!5m2!1sen!2sus"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="RW Construction Service Areas - Las Vegas Valley"
              ></iframe>
            </div>
          </div>

          <div className="space-y-4">
            <div className="bg-[#F8F6F3] rounded-2xl p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-[#FF6B35] rounded-full flex items-center justify-center">
                  <i className="ri-map-pin-line text-white text-lg"></i>
                </div>
                <h3 className="text-xl font-bold text-[#2C2C2C]">Las Vegas Valley</h3>
                <span className="text-xs bg-[#FF6B35]/10 text-[#FF6B35] px-2 py-1 rounded-full font-medium">Full Service</span>
              </div>
              
              <div className="grid grid-cols-3 gap-2 max-h-[280px] overflow-y-auto pr-2">
                {serviceAreas.filter(a => a.description === 'Full service coverage' || a.description === 'Main service hub').map((area) => (
                  area.link ? (
                    <Link
                      key={area.name}
                      to={area.link}
                      onMouseEnter={() => setActiveArea(area.name)}
                      onMouseLeave={() => setActiveArea(null)}
                      className={`text-left px-3 py-2 rounded-lg text-sm transition-all cursor-pointer ${
                        activeArea === area.name
                          ? 'bg-[#FF6B35] text-white'
                          : 'bg-white text-gray-700 hover:bg-[#FF6B35]/10'
                      }`}
                    >
                      <div className="flex items-center gap-2">
                        <i className={`ri-checkbox-circle-fill text-xs ${activeArea === area.name ? 'text-white' : 'text-[#FF6B35]'}`}></i>
                        <span className="truncate">{area.name}</span>
                      </div>
                    </Link>
                  ) : (
                    <button
                      key={area.name}
                      onMouseEnter={() => setActiveArea(area.name)}
                      onMouseLeave={() => setActiveArea(null)}
                      className={`text-left px-3 py-2 rounded-lg text-sm transition-all cursor-pointer ${
                        activeArea === area.name
                          ? 'bg-[#FF6B35] text-white'
                          : 'bg-white text-gray-700 hover:bg-[#FF6B35]/10'
                      }`}
                    >
                      <div className="flex items-center gap-2">
                        <i className={`ri-checkbox-circle-fill text-xs ${activeArea === area.name ? 'text-white' : 'text-[#FF6B35]'}`}></i>
                        <span className="truncate">{area.name}</span>
                      </div>
                    </button>
                  )
                ))}
              </div>
            </div>

            <div className="bg-[#2C2C2C] rounded-2xl p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center">
                  <i className="ri-road-map-line text-white text-lg"></i>
                </div>
                <h3 className="text-xl font-bold text-white">Extended Coverage</h3>
                <span className="text-xs bg-white/10 text-white/80 px-2 py-1 rounded-full font-medium">45-Mile Radius</span>
              </div>
              
              <div className="grid grid-cols-3 gap-2">
                {serviceAreas.filter(a => a.description === 'Extended coverage').map((area) => (
                  <button
                    key={area.name}
                    onMouseEnter={() => setActiveArea(area.name)}
                    onMouseLeave={() => setActiveArea(null)}
                    className={`text-left px-3 py-2 rounded-lg text-sm transition-all cursor-pointer ${
                      activeArea === area.name
                        ? 'bg-[#FF6B35] text-white'
                        : 'bg-white/10 text-white/90 hover:bg-white/20'
                    }`}
                  >
                    <div className="flex items-center gap-2">
                      <i className={`ri-checkbox-circle-fill text-xs ${activeArea === area.name ? 'text-white' : 'text-[#FF6B35]'}`}></i>
                      <span className="truncate">{area.name}</span>
                    </div>
                  </button>
                ))}
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div className="bg-[#FF6B35] rounded-2xl p-5 text-white">
                <div className="flex items-center gap-2 mb-2">
                  <i className="ri-phone-line text-xl"></i>
                  <span className="font-bold">Call Us Today</span>
                </div>
                <a href="tel:7025001790" className="text-2xl font-bold hover:underline cursor-pointer">(702) 500-1790</a>
                <p className="text-white/80 text-sm mt-2">Free estimates for all areas</p>
              </div>

              <div className="bg-white border border-gray-200 rounded-2xl p-5">
                <h4 className="font-bold text-[#2C2C2C] mb-2">Not Sure If We Serve Your Area?</h4>
                <p className="text-gray-600 text-sm mb-3">Contact us today!</p>
                <a
                  href="#contact"
                  onClick={(e) => {
                    e.preventDefault();
                    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="inline-flex items-center gap-2 bg-[#2C2C2C] text-white px-4 py-2 rounded-full text-sm font-semibold hover:bg-[#1A1A1A] transition-colors cursor-pointer whitespace-nowrap"
                >
                  Get Free Estimate
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
